import { makeStyles } from "tss-react/mui"
import { getCategoryColors } from "../../../../mp-core/themes/categoryColors"

type StylesParams = {
  category?: string
  clickable?: boolean
  leftBarColor?: "primary" | "secondary"
}

export const useStyles = makeStyles<StylesParams>()(
  (
    { spacing, palette, mixins },
    { category, clickable, leftBarColor = "secondary" }
  ) => ({
    root: {
      display: "flex",
      flexDirection: "row",
      gap: spacing(5),
      alignItems: "center",
      position: "relative",
      padding: spacing(4, 5),

      ...(clickable
        ? {
            cursor: "pointer",
            border: `1px solid ${palette.secondary[300]}`,

            "&:hover": {
              background: `linear-gradient(180deg, ${palette.background.paper} 50%, ${palette.secondary[50]} 100%)`,
              textDecoration: "none",
              color: "inherit"
            },
            "&:focus, &:focus-visible": {
              ...mixins.focusRing.ring
            }
          }
        : {})
    },
    leftBar: {
      width: "0.563rem",
      height: "100%",
      position: "absolute",
      left: 0,
      backgroundColor: getCategoryColors(category)[leftBarColor],
      zIndex: 1
    },
    content: {
      padding: "0 !important"
    },
    icon: {
      width: "60px",
      height: "60px",
      flexShrink: 0
    },
    actions: {
      flexDirection: "column",
      alignItems: "stretch",
      gap: spacing(2),
      padding: 0,
      marginLeft: "auto",

      [`& > :not(:first-of-type)`]: {
        marginLeft: 0
      }
    }
  })
)
